<template>
  <div class="not-found">
    <h1 class="not-found__title">404</h1>
    <p class="not-found__text">Oops! 页面未找到</p>
    <router-link to="/" class="not-found__button">返回首页</router-link>
  </div>
</template>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #1890ff;
  color: #fff;
}

.not-found__title {
  font-size: 6rem;
  margin-bottom: 2rem;
}

.not-found__text {
  font-size: 2rem;
  margin-bottom: 2rem;
}

.not-found__button {
  padding: 1rem 2rem;
  background-color: #fff;
  color: #1890ff;
  text-decoration: none;
  font-size: 1.5rem;
  border-radius: 4px;
}
</style>